import * as yup from 'yup';
import i18n from 'i18n';

export const personalDetailsSchema = yup.object().shape({
  firstName: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.firstNameRequired')),
  lastName: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.lastNameRequired')),
  phoneNumber: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.phoneNumberRequired')),
  companyEmail: yup
    .string()
    .email(() => i18n.t('website:auth.register.personalDetails.validation.emailInvalid'))
    .required(() => i18n.t('website:auth.register.personalDetails.validation.emailRequired')),
  password: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.passwordRequired')),
  confirmPassword: yup
    .string()
    .required(() => i18n.t('website:auth.register.personalDetails.validation.confirmPasswordRequired'))
    .oneOf([yup.ref('password')], () => i18n.t('website:auth.register.personalDetails.validation.passwordMismatch')),
});

export const personalDetailsSchemaBuyers = yup.object().shape({
  firstName: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.firstNameRequired')),
  lastName: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.lastNameRequired')),
  phoneNumber: yup.string().required(() => i18n.t('website:auth.register.personalDetails.validation.phoneNumberRequired')),
  companyEmail: yup
    .string()
    .email(() => i18n.t('website:auth.register.personalDetails.validation.emailInvalid'))
    .required(() => i18n.t('website:auth.register.personalDetails.validation.emailRequired')),
});
